import styled from 'styled-components';

export const Wrapper = styled.p`
  margin: 0;
  margin-bottom: -4px;
`;

export const Image = styled.img``;
